import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { LocationSetsActions } from './location-sets.actions';
import { LocationSetsSelectors } from './location-sets.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {LocationSet} from '@emm/core/models/location-set.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {getActionQueries} from '@emm/core/util/ngrx.util';
import {State as CoreState} from '@emm/core/store/core.reducer';


export interface LocationSetsQueries extends AsyncActionQueries {
    filter$: Observable<string>;
    filteredLocationSets$: Observable<LocationSet[]>;
    childLocationSets$: Observable<LocationSet[]>;
    isChainMenu$: Observable<boolean>;
    selected$: Observable<LocationSet>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagementLocationSetsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    dispatch = {
        loadLocationsByParent: (id: string) =>
            this.store.dispatch(LocationSetsActions.loadLocationsByParent({ id })),
        loadChildLocations: (tag: string) =>
            this.store.dispatch(LocationSetsActions.loadChildLocations({ tag })),
        addChildLocations: (parentTag: string, childTags: any) =>
            this.store.dispatch(LocationSetsActions.addChildLocations({ parentTag, childTags })),
        deleteLocationSet: (tag: string) =>
            this.store.dispatch(LocationSetsActions.deleteLocationSet({ tag })),
        removeChildLocation: (parentTag: string, childTag: string) =>
            this.store.dispatch(LocationSetsActions.removeChildLocation({ parentTag, childTag })),
        selectLocationSet: (tag: string, locationSet: LocationSet) =>
            this.store.dispatch(LocationSetsActions.select({ tag, locationSet })),
        updateFilter: (filter: string) =>
            this.store.dispatch(LocationSetsActions.updateFilter({ filter })),
        openAddLocationDialog: () => this.store.dispatch(LocationSetsActions.openAddDialog()),
    };

    queries: LocationSetsQueries = {
        filter$: this.select(LocationSetsSelectors.getFilter),
        filteredLocationSets$: this.select(LocationSetsSelectors.getFilteredLocationSets),
        childLocationSets$: this.select(LocationSetsSelectors.getChildLocationSets),
        isChainMenu$: this.select(LocationSetsSelectors.getIsChainMenu),
        selected$: this.select(LocationSetsSelectors.getSelected),
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: LocationSetsActions,
            actions$: this.actions$,
        })
    };

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, LocationSetsSelectors);
    }

}
